import { Store, select } from '@ngrx/store';

import { LoginState } from './login.reducer';
import { LoginSubmit } from './login.actions';
import { loginQuery } from './login.selectors';
import { Injectable } from '@angular/core';

import { LoginRequest } from '../data/login.model';

@Injectable({
  providedIn: 'root',
})
export class LoginFacade {
  servererror$ = this.store$.pipe(select(loginQuery.getLoginError));
  submitting$ = this.store$.pipe(select(loginQuery.isSubbmitting));

  constructor(private store$: Store<LoginState>) {}

  loginSubmit(data: LoginRequest): void {
    this.store$.dispatch(new LoginSubmit(data));
  }
}
